import { useTranslation } from "react-i18next";

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const nextLang = i18n.language === "en" ? "vi" : "en";
    i18n.changeLanguage(nextLang);
    localStorage.setItem("language", nextLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="rounded-lg px-3 py-2 text-lg transition-colors hover:bg-gray-200"
      title={i18n.language === "en" ? "Switch to Vietnamese" : "Chuyển sang tiếng Anh"}
    >
      {i18n.language === "vi" ? "🇻🇳" : "🇺🇸"}
    </button>
  );
};
